import JSEncrypt from 'jsencrypt'
import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'
import moment from 'moment'
// 处理多维数组降一维
export function parseArr(arr) {
	let res = []
	arr.forEach((item) => {
		res = (item instanceof Array) ? [...res, ...parseArr(item)] : [...res, item]
	})
	return res
}

export function getRoutes(menuList) {
	const noChildren = menuList.filter(item => {
		return !item.children
	})
	const hasChildren = menuList.filter(item => {
		return item.children
	})
	const child = hasChildren.map(item => {
		return getRoutes(item.children)
	})
	const path = noChildren.map(item => {
		return { ...item }
	})

	return [...path, ...child]
}

// 根据权限筛选Menu
export function filterMenu(list = [], configs = [], listName = 'menuList') {
	// 模拟权限
	// const configs = []
	const Node = []
	// 错误处理
	if (!(list instanceof Array)) {
		console.error(`${listName}并不是一个数组类型`)
	}
	if (configs.length === 0) {
		return list
	}
	list.forEach(item => {
		if (item.children) {
			if (filterMenu(item.children).length > 0) {
				Node.push({ ...item, children: filterMenu(item.children, configs, `key值为-${item.key}的children`) })
			}
		} else {
			if (configs.includes(item.key)) {
				Node.push(item)
			}
		}
	})
	return Node
}

// 判断是否为有值得对象
export function isObject(obj) {
	if (!obj) {
		return false
	}
	const keyArr = Object.keys(obj)
	// console.log(keyArr)
	if (keyArr.length > 0) {
		return true
	}
	else {
		return false
	}
}

// 判断对象数组
export function isObjArr(value) {
	if (Object.prototype.toString.call(value) === '[object Array]') {
		return 'arr'
	} else if (Object.prototype.toString.call(value) === '[object Object]') {
		return 'obj'
	} else {
		return false
	}
}


// #region getQueryString 获取请求参数
export const getQueryString = (search, key) => {
	console.log(key)
	search = decodeURIComponent(search)
	// key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
	var regex = new RegExp('[\\?&,{ ]' + key + '=([^&#,}]*)', 'i'),
		results = regex.exec(search)
	return results == null ? '' : results[1]
}
// #endregion

//生成随机数 字母+数字
export const getRandom = () => {
	let random = ''
	const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890'
	for (let i = 0; i < 64; i++) {
		const index = Math.floor(Math.random() * 57)
		random += str[index]
	}
	return random
}
//随机数  数字
export const getRandomN = () =>{
	let random = ''
	const str = '1234567890'
	for (let i = 0; i < 10; i++) {
		const index = Math.floor(Math.random() * 9)
		random += str[index]
	}
	return moment(new Date()).format('YYYYMMDD')+random
}
//公钥
const PUB_KEY =`-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtFd8wHjb2gZnfBAyhrjr
viCen3dmUbZpGCu1qc0pMkdCuGYeY5g3ubz8UE4+cx3mDvi8emtdO2x7MNhoPhp4
38pa6K92gLoIgYCrfcUGQQDjMSD2EajSNhnqyYh2dL37n6DUMUDoUmVC+O3+U06A
beslXMGbkHGd5yrnN4BIsgSMrZDMvIZjbZzTeVgHlWEnm67wbNuO8zmzIpsCJ5JQ
pxodv+Ot3dBWT+pv9HMg+inoYiRaKRdDWWrRyaNddC962fFqaapmgRYHq0Okls1C
rTfBhJji4W5sDr9V5/sjSCv+tYK9/zVncDA0iWXXuuuWm3vB8TurW7JUomKOlUbI
VQIDAQAB
-----END PUBLIC KEY-----`
//私钥
const PRIV_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC0V3zAeNvaBmd8
EDKGuOu+IJ6fd2ZRtmkYK7WpzSkyR0K4Zh5jmDe5vPxQTj5zHeYO+Lx6a107bHsw
2Gg+Gnjfylror3aAugiBgKt9xQZBAOMxIPYRqNI2GerJiHZ0vfufoNQxQOhSZUL4
7f5TToBt6yVcwZuQcZ3nKuc3gEiyBIytkMy8hmNtnNN5WAeVYSebrvBs247zObMi
mwInklCnGh2/463d0FZP6m/0cyD6KehiJFopF0NZatHJo110L3rZ8WppqmaBFger
Q6SWzUKtN8GEmOLhbmwOv1Xn+yNIK/61gr3/NWdwMDSJZde665abe8HxO6tbslSi
Yo6VRshVAgMBAAECggEARGDbs1rf+VXuTPMTRVO+RvO1UT+Dcz4XsQt5sO1STncI
jERkB11C29EVVhmkwh83CLw1MrGcwxhJyWZ0d/+vjyL5vzowU3S2Huw7mc9npKQC
gLE/u8hoFA1VoZ51U6RpUMg5TIeQzxUIBLywbsPYHFVJcFcUdfsuZOU2kCu65IwD
izWsYuikKhyqn5Rs5iyAa0h+uYvEZFwVNIwJFf+K4TMEFgT6NszISYeYMCc6mpGQ
dtzixgahHyDaMSM/suzlN8UWYOLRczKOvFan1WaaQCcZvDBivWoQS7x11QzQwKpW
oYLXAniT23yU2yAG9nUIDkGrt1secSqyesSZDye+YQKBgQDpssIESRO0ef6c5HBW
MWinvp/k03M3x0FCW/5BM3CvAyJuvdCGne+M4rjDUmRBa0g5br7oOosQRrSFhuQm
Dt1FBfaGBE7dvca2yGRZrGlpHm1+yjDJ2CXo/YcNxAGI1mkvrAgQxbVqPperNgxv
IxsInP35zyypvOdvRBahqIY8SQKBgQDFjTslXvzLVjjsqSC4my++g3i0cSbW8EuK
8oHzfFdGvyKz6V6S0T4VN4AD78tdg+XNz9RSQ4GGXnw4kB9WfHGJsQ1nW6vjXEw8
fSeCbGOrASlpxUY0RwQmPwvyCiFfNkEfC7B4MiNbvJF/GTcKGJUN1NpBPETo3xO3
Ou2hiSGzrQKBgEXZS+wD+4PBwrwZ+wmIEwOwEhJOsO1G/NZcsI3EVjW49h2rVhwm
MGcnjJm0koqLCjdARocamF3xBBu0yZQmdTQgKCK+PuQ/yJjxJC05PvhQQ+HVhOeP
VyVgQXF32A2SKDY7cN2yehqbQrHFocnF8FqOscpshajl8TZsX2dJ+3UhAoGBAJrL
zNG+uYU3XcmLyRj+eQ3mhPmXRGDdz8PjvJInF1hXQwEI11Nh5CzJ3WS4THlNdg+s
T2nafa7lcJ79x6CESI8lDiS0P18bnp0zUHcxKXQAqAu6SgWCtCyn8FtLNtUddS+3
gCLe3rfubW/TOT6O/pTk+dRuPmzfB9rmsPeHtcHNAoGBAMnOlhzd4caonk7bq5b2
qAwkd5p18GZwe1SEqOhS0DMsJw0n7bXOdgTw4IfryCuwhdR9P3Lp7qzlC6SpZRWP
ZND/rzDJzsCOtUmsjca5fFI0gu/G6xcH985Hrv21f5yeGki11L492huvK99pXrK6
dktAnagKGaCOBnUllGptb7bm
-----END PRIVATE KEY-----
`
//RSA加密
export const encrypt = (text) => {
	const encrypt = new JSEncrypt();
	encrypt.setPublicKey(PUB_KEY);
	const encrypted = encrypt.encrypt(text);
	return encrypted;
}
//RSA解密
export const decrypt = (text) =>{
	const decrypt = new JSEncrypt();
	decrypt.setPrivateKey(PRIV_KEY);
	const decrypted = decrypt.decrypt(text);
	return decrypted;
}
//base64
export const base64 = (text) =>{
	let base64ted = Base64.stringify(Utf8.parse(text))
	return base64ted
}
//密文+号处理
export const URLencode = (text) =>{
	return text.replace(/[+]/g,'%2B')
}
